import React from "react";

import { Navigate } from "react-router-dom";
import { useSelectAuth, useSelectPrivateUiAllowed } from "../../store/state";
import { useCurrentProjectState } from "../../lib/custom_hooks";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireProjectId?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireProjectId }) => {
  const auth = useSelectAuth();
  const privateUiAllowed = useSelectPrivateUiAllowed();
  const { projectId } = useCurrentProjectState();
  const accessToken = auth?.accessToken;
  if (!accessToken) {
    // a boot whose refresh is still in flight, or is waiting out a scheduled retry, has
    // not been signed out -- it is reconnecting. Rendering nothing keeps the reconnecting notice
    // up; redirecting here would send a signed-in user to the login page over a backend outage.
    // Only an idle auth slice with no token means the session is really over.
    if (auth?.isRefreshing || auth?.refreshUnavailable) {
      return null;
    }
    return <Navigate to="/" />;
  }

  // past an idle end the server has not confirmed yet, the session is neither live nor over: the
  // page stays hidden behind the connection notice, and sending it anywhere would be a guess
  if (!privateUiAllowed) return null;

  if (requireProjectId && !projectId) {
    return <Navigate to="/project" />;
  }

  return <>{children}</>;
};
